<ep-card variant="elevated" class="w-full">
  <div class="flex flex-col gap-3">
    <div class="flex items-start justify-between gap-4">
      <div class="flex flex-col gap-1 min-w-0">
        <h6 class="truncate">{{ request().requestedName }}</h6>
        <span class="body-sm text-fg-subtle truncate">{{ displayedClientId() }}</span>
      </div>
      <ep-chip size="small" variant="alt" [color]="statusChip().color">
        {{ statusChip().label }}
      </ep-chip>
    </div>

    <div class="body-xs text-fg-muted flex flex-wrap gap-x-2">
      @if (showRequester()) {
        <span>Requested by {{ request().requestedByName }} ({{ request().requestedByEmail }})</span>
        <span aria-hidden="true">·</span>
        <span>{{ request().createdAt | date: 'mediumDate' }}</span>
      } @else {
        <span>Requested {{ request().createdAt | date: 'mediumDate' }}</span>
      }
      @if (showReview()) {
        <span aria-hidden="true">·</span>
        <span>
          Reviewed {{ request().reviewedAt | date: 'mediumDate' }}
          @if (request().reviewedByEmail) {
            by {{ request().reviewedByEmail }}
          }
        </span>
      }
    </div>

    @if (showDenyReason()) {
      <ep-alert type="alert" color="danger" variant="alt">
        <span slot="header">Reason</span>
        <span slot="subtext">{{ request().denyReason }}</span>
      </ep-alert>
    }

    <ng-content />
  </div>

  <ng-content select="[slot=actions]" />

  @if (showOpenClient()) {
    <ep-button
      slot="actions"
      variant="quiet"
      color="primary"
      size="small"
      [routerLink]="['/clients', request().finalClientId]"
    >
      Open client →
    </ep-button>
  }
</ep-card>
